import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { ImportPatentsStatus } from '../repositories/import-patents-repository';

export interface ImportPatentsState extends ImportPatentsStatus {}

export const FtoReportImportPatentsModel = Symbol.for('FtoReportImportPatentsModel');

export interface FtoReportImportPatentsModel extends Model<ImportPatentsState>, Disposable {

}
